module.exports = __webpack_public_path__ + "media/sucesso.7d181830.mp3";